export class ContactHelper {

  static readonly CONTACT_TYPE_PLANER = 1; // Designer
  static readonly CONTACT_TYPE_TRADE = 2;
  static readonly CONTACT_TYPE_PRIVATE = 3;
}
